<template>
    <div class="side-menu">
      <ul class="main-menu" v-click-outside="closeAllSubMenus">
        <li class="main-menu-item"  @click="toggleSubMenu('kits')">
          <div class="main-menu-item-div" :class="{ active: showsubmenu.kits }">
            <span>Kits</span>
            <img
                class="toggle-icon"
                :class="{ rotated: showsubmenu.kits }"
                src="../../images/dashboard/down-blue.png"
                alt="toggle"
            />
            </div>
          <ul v-if="showsubmenu.kits" class="sub-menu">
            <li class="sub-menu-item" @click="navigate(0,'Test Kits')">Test Kits</li>
            <li class="sub-menu-item" @click="navigate(4,'Outliers')">Outliers</li>
            <li class="sub-menu-item" @click="navigate(12,'Import Kits')">Import Kits</li>
            <li class="sub-menu-item" @click="navigate(13,'Import Inactive')">Import Inactive</li>
            <li class="sub-menu-item" @click="navigate(15,'Inactive Kits')">Inactive Kits</li>
          </ul>
        </li>
        <li class="main-menu-item" :class="{ active: showsubmenu.user }" @click="toggleSubMenu('user')">
          <div class="main-menu-item-div" :class="{ active: showsubmenu.user }">
            <span>User</span>
            <img
                class="toggle-icon"
                :class="{ rotated: showsubmenu.user }"
                src="../../images/dashboard/down-blue.png"
                alt="toggle"
          />
          </div>
          <ul v-if="showsubmenu.user" class="sub-menu">
            <li class="sub-menu-item" @click="navigate(1,'Admins')">Admins</li>
            <li class="sub-menu-item" @click="navigate(2, 'Lab Operators')">Lab Operators</li>
            <li class="sub-menu-item" @click="navigate(8, 'Customers')">Customers</li>
          </ul>
        </li>
        <li class="main-menu-item" :class="{ active: showsubmenu.inventory }" @click="toggleSubMenu('inventory')">
          <div class="main-menu-item-div" :class="{ active: showsubmenu.inventory }">
            <span>Inventory</span>
            <img
                class="toggle-icon"
                :class="{ rotated: showsubmenu.inventory }"
                src="../../images/dashboard/down-blue.png"
                alt="toggle"
          />
          </div>
          <ul v-if="showsubmenu.inventory" class="sub-menu">
            <li class="sub-menu-item" @click="navigate(14,'Kit Generation')">Kit Generation</li>
            <li class="sub-menu-item" @click="navigate(18, 'Items')">Items</li>
            <li class="sub-menu-item" @click="navigate(16,'Amazon')" >Amazon</li>
          </ul>
        </li>
        <li class="main-menu-item" :class="{ active: showsubmenu.order }" @click="toggleSubMenu('order')">
          <div class="main-menu-item-div" :class="{ active: showsubmenu.order }">
            <span>User</span>
            <img
                class="toggle-icon"
                :class="{ rotated: showsubmenu.order }"
                src="../../images/dashboard/down-blue.png"
                alt="toggle"
          />
          </div>
          <ul v-if="showsubmenu.order" class="sub-menu">
            <li class="sub-menu-item" @click="navigate(11,'Woo Orders')">Woo Orders</li>
            <li class="sub-menu-item" @click="navigate(5,'Reports')">Reports</li>
            <li class="sub-menu-item" @click="navigate(17,'Sales')">Sales</li>
          </ul>
        </li>
        <li class="main-menu-item" :class="{ active: showsubmenu.automation }" @click="toggleSubMenu('automation')">
          <div class="main-menu-item-div" :class="{ active: showsubmenu.automation }">
            <span>Automation</span>
            <img
                class="toggle-icon"
                :class="{ rotated: showsubmenu.automation }"
                src="../../images/dashboard/down-blue.png"
                alt="toggle"
          />
          </div>
          <ul v-if="showsubmenu.automation" class="sub-menu">
            <li class="sub-menu-item" @click="navigate(10,'Job Logs')">Job Logs</li>
          </ul>
        </li>
        <li class="main-menu-item" :class="{ active: showsubmenu.tool }" @click="toggleSubMenu('tool')">
          <div class="main-menu-item-div" :class="{ active: showsubmenu.tool }">
            <span>Tool</span>
            <img
                class="toggle-icon"
                :class="{ rotated: showsubmenu.tool }"
                src="../../images/dashboard/down-blue.png"
                alt="toggle"
          />
          </div>
          <ul v-if="showsubmenu.tool" class="sub-menu">
            <li class="sub-menu-item" @click="navigate(6,'QR Generator')">QR Generator</li>
            <li class="sub-menu-item" @click="navigate(7,'URL Generator')">URL Generator</li>
          </ul>
        </li>
        <li class="main-menu-item" :class="{ active: showsubmenu.others }" @click="toggleSubMenu('others')">
          <div class="main-menu-item-div" :class="{ active: showsubmenu.others }">
            <span>Others</span>
            <img
                class="toggle-icon"
                :class="{ rotated: showsubmenu.others }"
                src="../../images/dashboard/down-blue.png"
                alt="toggle"
          />
          </div>
          <ul v-if="showsubmenu.others" class="sub-menu">
            <li class="sub-menu-item" @click="navigate(3,'Research')">Research</li>
            <li class="sub-menu-item" @click="navigate(9,'Federal Holidays')">Federal Holidays</li>
          </ul>
        </li>
        <!-- Add the rest of your menu sections here following the same pattern -->
      </ul>
    </div>
  </template>
  
  <script>
  import { mapActions } from "vuex";
  export default {
    name: "OptionsmMenu",
    data() {
      return {
        showsubmenu: {
          user: false,
          order:false,
          inventory:false,
          kits:false,
          automation:false,
          tool:false,
          others:false
        },
      };
    },
    methods: {
        ...mapActions([
        "setStatusFilter", 
        "setOverDueByShipped",
        "getAdminInfoList", 
        "setAdminPginationPage", 
        "getLabOperatorInfoList", 
        "sendSearchReqAnalytics", 
        "setAnalyticsHead", 
        "getPendingInfoList", 
        "getAverageReportResultList",
        "getContactCustomers",
        "setCustomerCount",
        "getFederalHolidays",
        "getScheduledJoblogs",
        "getWooOrders",
        "setLoader",
        "resetState",
        "setViewReport",
        "setInventory",
        "setLocations",
        "setPagination", 
        "setFillocation",
        "setFilItem",
        "setItems",
        "setPage",
        "setInvKits",
        "getInactiveList",
        "setAmazonFbaInv",
        "setSalesData",
        "setWooSalesData",
        "setShowinvkit",
        "setCityState"
      ]),
      toggleSubMenu(menu) {
        for (let key in this.showsubmenu) {
          if (key !== menu) {
            this.showsubmenu[key] = false;
          }
        }
        // Toggle the submenu visibility based on the clicked menu item
        this.showsubmenu[menu] = !this.showsubmenu[menu];
      },
      closeAllSubMenus(){
        for (let key in this.showsubmenu) {
          this.showsubmenu[key] = false;
        }
      },
      navigate(val,label) {
        for (let key in this.showsubmenu) {
          this.showsubmenu[key] = false;
        }
        this.resetState();
        if (val === 0) {
            this.setStatusFilter([]);
            this.getAdminInfoList("kits").then(res => {
            this.$eventBus.$emit("title", { show: false, value: val , label: label});
            });
            this.$eventBus.$emit("showoutlinerfilters", { showfilter: true ,value: val});  
        } else if (val === 1) {
            this.setAdminPginationPage(null).then(() => {
            this.getAdminInfoList("admins").then(res => {
                this.$eventBus.$emit("title", { show: false, value: val , label: label});
            });
            });
        } else  if (val === 2) {
            this.setAdminPginationPage(null).then(() => {
            this.getLabOperatorInfoList("labOps").then(res => {
                this.$eventBus.$emit("title", { show: false, value: val , label: label});
            });
            });
        }  else  if (val === 3) {
            this.sendSearchReqAnalytics().then(res => {
                this.setAnalyticsHead({status:3,type:null,show:false,item:null,count:null,total:null});
                this.$eventBus.$emit("title", { show: false, value: val , label: label});
            });
            this.setCityState();
        }  else  if (val === 4) {
            this.setOverDueByShipped(null);
            this.getPendingInfoList("pending").then(res => {
                this.$eventBus.$emit("title", { show: false, value: val , label: label});
                });
        }  else if (val === 5) {
          this.setAdminPginationPage(null).then(() => {
          this.getAverageReportResultList("avg").then(res => {
             this.$eventBus.$emit("title", { show: false, value: val , label: label});
          });
          });
        }  else  if (val === 6) {
              this.$eventBus.$emit("title", { show: false, value: val , label: label});
        }  else if (val === 7) {
            this.$eventBus.$emit("title", { show: false, value: val , label: label});
        } else  if (val === 8) {
            this.setAdminPginationPage(null).then(() => {
                this.setCustomerCount(0).then(() => {
                this.getContactCustomers(null).then(res => {
                    this.$eventBus.$emit("title", { show: false, value: val , label: label});
                });
                });
            });
        } else  if (val === 9) {
            this.getFederalHolidays().then(res => {
                this.$eventBus.$emit("title", { show: false, value: val , label: label});
            });
        } else  if (val === 10) {
          this.getScheduledJoblogs().then(res => {
            this.$eventBus.$emit("title", { show: false, value: val , label: label});
          });
        } else  if (val === 11) {
            this.setLoader(true);
            this.getWooOrders().then(async res => {
                this.setLoader(false);
                this.$eventBus.$emit("title", { show: false, value: val , label: label});
            });
        } else  if (val === 12) {
            this.$eventBus.$emit("title", { show: false, value: val , label: label});
        } else  if (val === 13) {
            this.$eventBus.$emit("title", { show: false, value: val , label: label});
        } else  if (val === 14) {
            this.setLoader(true);
            this.setLocations();
            this.setItems();
            this.setFillocation('');
            this.setFilItem('');
            this.setInvKits(false);
            this.setPage(1).then(() => {
              this.setInventory().then(async res => {
                this.setLoader(false);
                this.$eventBus.$emit("title", { show: false, value: val , label: label});
                this.setShowinvkit(true);
              });
            });
        } else  if (val === 15) {
          this.getInactiveList("kits").then(res => {
            this.$eventBus.$emit("title", { show: false, value: val , label: label});
          });
        }  else  if (val === 16) {
          this.setAmazonFbaInv();
          this.$eventBus.$emit("title", { show: false, value: val , label: label});
        } else  if (val === 17) {
            this.setSalesData();
            this.setWooSalesData();
            this.$eventBus.$emit("title", { show: false, value: val , label: label});
        }  else  if (val === 18) {
          this.setLoader(true);
            this.setLocations();
            this.setItems();
            this.setFillocation('');
            this.setFilItem('');
            this.setInvKits(false);
            this.setPage(1).then(() => {
              this.setInventory().then(async res => {
                this.setLoader(false);
                this.$eventBus.$emit("title", { show: false, value: 14 });
                this.setShowinvkit(false);
              });
            });
        }
      }
    },
  };
  </script>
<style scoped>
  .side-menu {
  background-color: #fff;
  padding-top: 15px;
  padding-bottom: 15px;
  width: 250px;
  height: 100vh; /* Full height */
  display: flex;
  flex-direction: column;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
}

.main-menu {
  display: flex;
  flex-direction: column;
  list-style: none;
  padding: 0;
  margin: 0;
  color: #005EB8;
}

.main-menu-item {
  position: relative;
  cursor: pointer;
  display: block;
  justify-content: space-between;
  align-items: center;
  transition: background-color 0.3s ease;
}



.sub-menu {
  background-color: #f0f0f0;
  color: #005EB8;
  padding-left: 20px;
  list-style: none;
  display: flex;
  flex-direction: column;
  padding: 0px 35px;
  border-bottom: 1px solid #eee;
}

.sub-menu-item {
  padding: 8px 0;
  cursor: pointer;
}

.sub-menu-item:hover {
  background-color: #ffffff;
}

.toggle-icon {
  height: 14px;
  transition: transform 0.3s ease;
}

.rotated {
  transform: rotate(180deg);
}

.active {
  background-color: #f0f0f0;
}

.main-menu-item-div{
  position: relative;
  padding: 10px 20px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background-color 0.3s ease;
  border-bottom: 1px solid #eee;
}
.main-menu-item-div:hover {
  background-color: #f5f5f5;
}


  </style>
  